import Component from "./component";

export default class Template extends Component {
  constructor(_$) {
    super(_$);
    this._$ = this._$.clone().attr("hidden", false);
  }
}
